module.exports = __webpack_public_path__ + "img/locationIcon.27400df1.svg";